/**
 * @license
 *
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Blockly React Component.
 * @author samelh@google.com (Sam El-Husseini)
 */

 import React from 'react';
 import './BlocklyComponent.css';
 import {useEffect, useRef, useState} from 'react';

 import Blockly from 'blockly/core';
 import {pythonGenerator} from 'blockly/python';
 import {javascriptGenerator} from 'blockly/javascript';
 import locale from 'blockly/msg/en';
 import 'blockly/blocks';
 import Plotly from 'plotly.js-dist';
 
 Blockly.setLocale(locale);

 function BlocklyComponent(props) {
    const blocklyDiv = useRef();
    const toolbox = useRef();
    let primaryWorkspace = useRef();
    const [pythonCode, setPythonCode] = useState("This is your 'Blockly Generator'. As you edit blocks your Python code will be generated here!");
    const [output, setOutput] = useState("This is your 'Blockly Terminal'. When you run code the output will be displayed here!");
    var trace = null;
    var layout = null;
    var index = 0;
    //const [lineIndex, setLineIndex] = useState(0); 
    var outputCurr = "";

    //only used by eval()
    // eslint-disable-next-line
    const setOutputStep = (x) => {
        outputCurr = outputCurr + '[' + index + '] ' + x + '\r\n';
        index = index + 1; 
    } 

    const runCode = () => {
        //clear text area
        outputCurr = "";
        index = 0;
        // Generate JavaScript code and run it.
        var code = javascriptGenerator.workspaceToCode(
            primaryWorkspace.current
        );
        console.log(code);
        try {
          //how to display this!!!!!!
          if (code.match(/window.alert/)) {
            code = code.replaceAll('window.alert', 'setOutputStep')
            // eslint-disable-next-line
            eval(code)
            setOutput(outputCurr);
          } else {
            // eslint-disable-next-line
            eval(code)
          }
        } catch (e) {
          alert(e);
        }
        
        if (trace) {
            Plotly.newPlot('myDiv', [trace], layout);
        }
        
    }

    const clearCode = () => {
        primaryWorkspace.current.clear();
        setPythonCode("This is your 'Blockly Generator'. As you edit blocks your Python code will be generated here!");
        setOutput("This is your 'Blockly Terminal'. When you run code the output will be displayed here!");
        //clear graph
        layout = null;
        trace = null;
        document.getElementById("myDiv").innerHTML = "";

    }

    const showSolution = () => {
        if(props.solutionXml) {
            primaryWorkspace.current.clear();
            Blockly.Xml.domToWorkspace(Blockly.Xml.textToDom(props.solutionXml), primaryWorkspace.current);
        }
    }
/*
    const stepCode = () => {
        // Generate JavaScript code
        var code = javascriptGenerator.workspaceToCode(
            primaryWorkspace.current
        );
        var lines = code.split(/\r?\n/).filter((str) => str !== '');
        setLineIndex(lineIndex + 1);

        if (lineIndex >= lines.length ) {
            alert("**You have reached the end of your code**");
            setLineIndex(0);
            
        } else {

            //get lines up to current line
            lines = lines.slice(0, lineIndex + 1);
            console.log(lines)
            try {
            //run current line of code 
            if (lines[lineIndex].match(/window.alert/)) {
                lines = lines.join("\r\n").replaceAll('window.alert', 'setOutputStep');
                console.log(lines);
                // eslint-disable-next-line
                eval(lines);
                setOutput(outputCurr);
            } else {
                // eslint-disable-next-line
                eval("");
            }
            } catch (e) {
            alert(e);
            }
        }
    }
    */
 
    useEffect(() => {
        
        const { initialXml, children, ...rest } = props;
        primaryWorkspace.current = Blockly.inject(
            blocklyDiv.current,
            {
                toolbox: toolbox.current,
                ...rest
            },
        );

        if (initialXml) {
            Blockly.Xml.domToWorkspace(Blockly.Xml.textToDom(initialXml), primaryWorkspace.current);
        }

        primaryWorkspace.current.addChangeListener(e => {
            if (e.type === Blockly.Events.FINISHED_LOADING) {
                setPythonCode("This is your 'Blockly Generator'. As you edit blocks your Python code will be generated here!");
                setOutput("This is your 'Blockly Terminal'. When you run code the output will be displayed here!");
            } else {
                var code = pythonGenerator.workspaceToCode(
                    primaryWorkspace.current
                );
                if (code === "") {
                    code = "This is your 'Blockly Generator'. As you edit blocks your Python code will be generated here!";
                    setOutput("This is your 'Blockly Terminal'. When you run code the output will be displayed here!");
                }
                //reset step index
                //setLineIndex(0);

                //reset code 
                setPythonCode(code);

            }
        });
    }, [primaryWorkspace, toolbox, blocklyDiv, props]);
 
    return (
    <React.Fragment>
        <section id="blocklyContainer">
            <button className="button1" onClick={runCode}>
                <span>Run Code </span>
            </button>
            <button className="button1" onClick={showSolution}>
                <span>Show Solution </span>
            </button>
            <div className="divider"/>
            <button className="button2" onClick={clearCode}>
                <span>Clear </span>
            </button>
            <div ref={blocklyDiv} id="blocklyDiv" />
        </section>
        <div style={{ display: 'none' }} ref={toolbox}>
            {props.children}
        </div>
        <div className="two-col">
            <div className="col1">
                <textarea
                className="textbox"
                id="code"
                value={pythonCode}
                readOnly
                 ></textarea>
            </div>
            <div className="col2">
                <textarea
                className="textbox"
                id="run"
                value={output}
                readOnly
                >
                </textarea>
                <div id='myDiv'></div>
            </div>
        </div>
    </React.Fragment>);
}
 
export default BlocklyComponent;
 